import React from "react";
import { Outlet } from "react-router-dom";
import axios from "axios";
import { useWauth } from "../../../auth/WauthProvider";


axios.interceptors.request.use(function (config) {
  const token = JSON.parse(localStorage.getItem("currentUser")).token;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  const salaId = localStorage.getItem("salaId");

  if (salaId && salaId > 0) {
    axios.defaults.headers.common["X-Sala-ID"] = salaId;
  }
  return config;
});

axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response) {
      if (401 === error.response.status) {
        window.location = "/logout";
        return Promise.reject(error);
      } else {
        return Promise.reject(error);
      }
    } else {
      return Promise.reject(error);
    }
  }
);

const Layout = () => {
  const { isAuthenticated, loginWithRedirect } = useWauth();

  if (!isAuthenticated) {
    loginWithRedirect();
    return;
  }

  return (
    <div className="flex flex-col min-h-screen bg-neutral-100">
      <Outlet />
    </div>
  );
};

export default Layout;
